import UIToolboxPage from './UIToolbox';

export default UIToolboxPage;
